<script lang="ts">
    import WidthBox from "../../components/WidthBox.svelte";
    import Header from "../../components/Header.svelte";
    import LibraryItem from "../../components/LibraryItem.svelte";
    import { t } from "@lernetz/svelte-translate";


    export let library;

</script>


<Header title={$t("library")} />
<WidthBox>
    <div class="mt-112">
        <div class="text-almost-black text-16">{$t("choose-library-item")}</div>
        <div class="mt-32 grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-16 sm:gap-24 content-center">
            {#each library as libraryItem}
                <LibraryItem model={libraryItem} />
            {/each}
        </div>
    </div>
</WidthBox>
